var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-panel center-align",class:_vm.cardStyle},[_c('p',[_c('i',{staticClass:"material-icons left"},[_vm._v(_vm._s(_vm.icon || _vm.defaultIcon))]),_vm._v(" "),_vm._t("default")],2)])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d1c7194","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/common/InformationCard.vue
// module id = 6a9w
// module chunks = 0 1